/**
 * Возможные виды действий над столбцом
 */
export type TActionColumn = EActionColumn.filter | EActionColumn.sort | EActionColumn.group | EActionColumn.summarize;

export enum EActionColumn {
    filter = 'filter',
    sort = 'sort',
    group = 'group',
    summarize = 'summarize',
}
